/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'
//import 'flexslider'

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    //alerts
    $('.site-alert__close').on('click',function(e){
        e.preventDefault();
        //fade out content
        $(this).parent().addClass("fade");
        //slide up pattern
        $(this).closest('.site-alert').delay(300).slideUp('slow', 'swing');
    });

    //OPEN SEARCH POPUP
    $('.open-search').magnificPopup({
        type:'inline',
        alignTop: true,
        modal: true,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade mfp-fullscreen',
        focus: '#s',
    });

    // close button on search popup
    $(document).on('click', '.close-search', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    // esc key search popup close.
    $(document).keyup(function(e) {
        if (e.keyCode === 27) {
            e.preventDefault();
            $.magnificPopup.close();
        }
    });
    
    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    //wrap the first word of this string in a span
    $('.js-first-word').each(function(){
         var string = $(this);
         string.html(string.html().replace(/([^\s]+)/, '<span>$1</span>'));
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();


    $('.js-play-video').on('click', function(e){
        e.preventDefault();

        //hide image
        $(this).hide();

        //play the video
        $(this).prev('iframe').css('opacity','1');
        $(this).prev('iframe')[0].src += "&autoplay=1";

    });

    $('#category').on('change',function(){
        var value = $(this).val();
        window.location.href = value;
    });

    $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();

      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    };

$(window).on('resize scroll', function() {

  $('.circle-chart').each(function() {
      //if section is in the viewport
    if ( $(this).isInViewport() ) {
      $(this).addClass('inview');
    } else {
      $(this).removeClass('inview');
    }
  });

});


})(jQuery)
